import { asyncOperation, clientRepo, useUser } from "@zickko/client";
import { EmailKey, InboundEmail } from "@zickko/shared";
import { useOrg } from "../../providers/OrgProvider";

type Props = {
  email: InboundEmail;
  onSelectEmail: () => void;
};

export const InboundEmailListItemWidget = (props: Props) => {
  const { org } = useOrg();
  const { user } = useUser();

  const { email, onSelectEmail } = props;
  const { headers, previewSnippet } = email;
  const senderName = headers.from?.name || "Unknown Sender";
  const subject = headers.subject || "No Subject";
  const snippet = previewSnippet || "No preview available";

  const markEmailAsRead = (emailId: string) => {
    asyncOperation({
      fn: () => {
        const emailKey: EmailKey = { emailId: emailId, orgId: org.id, uid: user.uid };
        return clientRepo.inboundEmail.merge(emailKey, { isRead: true });
      },
    });
  };

  const handleEmailClick = () => {
    onSelectEmail();
    if (!email.isRead) {
      setTimeout(() => {
        markEmailAsRead(email.id);
      }, 3000);
    }
  };

  return (
    <div className="email-list-item-widget-container" onClick={handleEmailClick}>
      <div className="email-list-item-widget">
        <div className="heading">
          <div className="sender">
            {senderName}
            {!email.isRead && <span className="unread-dot"></span>}
          </div>
          <div className="time">9 months ago</div>
        </div>
        <div className="subject">{subject}</div>
        <div className="mail-snippet">{snippet} . . . </div>
        <div className="tags">
          <div className="meeting-tag">meeting</div>
          <div className="work-tag">work</div>
          <div className="important-tag">important</div>
        </div>
      </div>
    </div>
  );
};
